<div [ngClass]="{ row: responsive }">
  @for (companyob of companies; track companyob) {
    <div
      mat-ripple
      [ngClass]="{ 'col-12 col-lg-6': responsive }"
      class="p-2 celo-cursor-pointer celo-hoverable item"
      (click)="editable ? edit.emit(companyob) : ''"
    >
      <div class="company">
        <div class="celo-break-word">
          <div class="text">
            @if (companyob.companyId) {
              <app-info-line
                [title]="companyob.companyName"
                [subtitles]="[
                  companyob.position,
                  companyob.departmentName
                    ? companyob.departmentName
                    : 'No department',
                  companyob.email,
                ]"
                [showBadge]="true"
                [workspaces]="[companyob]"
              ></app-info-line>
            }
          </div>
          @if (editable) {
            <div class="edit">
              <button
                mat-icon-button
                disableRipple
                class="celo-tertiary-button no-mat-hover"
              >
                <span>Edit</span>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
